import { AiOutlineClose } from "react-icons/ai";

const PopupCloseButton = () => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between bg-primary py-3 px-4 ">
        <h3 className="font-pop text-xl font-semibold text-white">Preview</h3>
        <AiOutlineClose className="cursor-pointer font-pop text-xl font-semibold text-white" />
      </div>
    </div>
  );
};

export default PopupCloseButton;
